import React, { useState, useEffect } from 'react';

import superiorEsquerda from './assets/toothbrush/superior-esquerda.svg';
import superiorDireita from './assets/toothbrush/superior-direita.svg';
import inferiorEsquerda from './assets/toothbrush/inferior-esquerda.svg';
import inferiorDireita from './assets/toothbrush/inferior-direita.svg';
import esquerdaFrontal from './assets/toothbrush/esquerda-frontal.svg';
import direitaFrontal from './assets/toothbrush/direita-frontal.svg';
import centroFrontal from './assets/toothbrush/centro-frontal.svg';

const AREAS = [
  'Superior Esquerda',
  'Superior Direita',
  'Inferior Esquerda',
  'Inferior Direita',
  'Esquerda Frontal',
  'Direita Frontal',
  'Centro Frontal'
];

const AREA_IMAGES = {
  'Superior Esquerda': superiorEsquerda,
  'Superior Direita': superiorDireita,
  'Inferior Esquerda': inferiorEsquerda,
  'Inferior Direita': inferiorDireita,
  'Esquerda Frontal': esquerdaFrontal,
  'Direita Frontal': direitaFrontal,
  'Centro Frontal': centroFrontal,
};

const ALARM_SOUND = 'https://actions.google.com/sounds/v1/alarms/beep_short.ogg';

function ToothbrushTimer() {
  const [currentArea, setCurrentArea] = useState(0);
  const [seconds, setSeconds] = useState(3);
  const [running, setRunning] = useState(false);

  useEffect(() => {
    let timer;
    if (running && currentArea < AREAS.length) {
      if (seconds > 0) {
        timer = setTimeout(() => setSeconds(seconds - 1), 1000);
      } else {
        playAlarm();
        if (currentArea < AREAS.length - 1) {
          setCurrentArea(currentArea + 1);
          setSeconds(3);
        } else {
          setRunning(false);
        }
      }
    }
    return () => clearTimeout(timer);
  }, [running, seconds, currentArea]);

  function playAlarm() {
    const audio = new window.Audio(ALARM_SOUND);
    audio.play();
  }

  function start() {
    setCurrentArea(0);
    setSeconds(3);
    setRunning(true);
  }

  function reset() {
    setCurrentArea(0);
    setSeconds(3);
    setRunning(false);
  }

  return (
    <div style={{ maxWidth: 400, margin: '40px auto', textAlign: 'center', fontFamily: 'sans-serif', padding: 24 }}>
      <div style={{ fontSize: 24, margin: '24px 0' }}>
        {running ? (
          <>
            <div style={{ marginBottom: 16 }}>
              <img
                src={AREA_IMAGES[AREAS[currentArea]]}
                alt={AREAS[currentArea]}
                style={{ width: 120, height: 120, background: '#fff', borderRadius: 12, border: '2px solid #1976d2' }}
              />
            </div>
            <strong>Área:</strong> {AREAS[currentArea]}<br />
            <strong>Tempo:</strong> {seconds}s
          </>
        ) : (
          <span>Pronto para começar?</span>
        )}
      </div>
      <button onClick={start} disabled={running} style={{ marginRight: 8, padding: '8px 16px', fontSize: 16 }}>Iniciar</button>
      <button onClick={reset} style={{ padding: '8px 16px', fontSize: 16 }}>Resetar</button>
      {(!running && currentArea === AREAS.length - 1 && seconds === 0) && (
        <div style={{ marginTop: 24, fontSize: 20, color: '#388e3c' }}>
          Parabéns! Escovação completa!
        </div>
      )}
      <div style={{ marginTop: 32, fontSize: 14, color: '#555' }}>
        <ul style={{ listStyle: 'none', padding: 0 }}>
          {AREAS.map((area, idx) => (
            <li key={area} style={{ margin: '6px 0', fontWeight: idx === currentArea ? 'bold' : 'normal', color: idx === currentArea ? '#1976d2' : '#555' }}>
              {idx + 1}. {area}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}

export default ToothbrushTimer;
